// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__Rqbm8","tab":"styles_tab__TyW6i","active":"styles_active__LWFSK"};